/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { useState } from 'react'
import Icon from '../../../../components/Icon'
import { Flex } from '../../../../components/Layout'
import DivisionSettings from '../../DivisionSettings'
import DivisionTeams from './DivisionTeams'

import ToolbarButton from './ToolbarButton'
import DivisionToolbarItem from './ToolbarItem'
import { useI18n } from '@shopify/react-i18n'

const RegistrationDivision = ({ division }) => {
  const { id, name, registration, teams } = division
  const [isOpen, setIsOpen] = useState(true)

  const [i18n] = useI18n()

  return (
    <div
      css={css`
        margin-bottom: 30px;
      `}
    >
      <Flex
        className={!isOpen ? 'is-closed' : ''}
        css={css`
          background: ${colors.HEADER};
          border-radius: 8px;
          padding: 8px;

          & ~ .list-container {
            .list-header {
              margin-bottom: 0;
            }

            .list-inner {
              margin-top: 8px;
              margin-bottom: 0;
            }
            transition: all 0.15s ease-in-out;
            max-height: ${teams?.length * 75}px;
            overflow: hidden;
            opacity: 1;
          }

          &.is-closed ~ .list-container {
            max-height: 0;
            opacity: 0;
            z-index: -100;
          }
        `}
      >
        <ToolbarButton onClick={() => setIsOpen((o) => !o)}>
          <Icon
            className={!isOpen ? 'is-closed' : ''}
            name={`angle-down`}
            color={colors.WHITE}
            fontSize={18}
          />
        </ToolbarButton>
        <div
          css={css`
            max-width: 200px;
            padding-right: 8px;
          `}
        >
          <h2
            css={css`
              font-weight: 700;
              font-size: 16px;
              line-height: 16px;
              text-transform: uppercase;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            `}
          >
            {name}
          </h2>
          {registration?.division_age?.name && (
            <div
              css={css`
                font-weight: 500;
                font-size: 14px;
                line-height: 14px;
                color: ${colors.PALE_SKY};
                margin-top: 4px;
              `}
            >
              {registration?.division_age?.name}
            </div>
          )}
        </div>
        <Flex justifyContent='space-around'>
          <DivisionToolbarItem
            title='GENDER'
            subTitle={registration?.division_gender?.name}
          />
          <DivisionToolbarItem
            title='PLAYERS'
            subTitle={
              registration?.total_players
                ? String(registration?.total_players)
                : '0'
            }
          />
          <DivisionToolbarItem
            title='DEPOSIT'
            subTitle={
              registration?.deposit
                ? i18n.formatCurrency(registration.deposit, {
                    currency: registration?.currency?.name,
                    form: 'short',
                  })
                : ''
            }
          />
          <DivisionToolbarItem
            title='COST'
            subTitle={
              registration?.team_cost
                ? i18n.formatCurrency(registration.team_cost, {
                    currency: registration?.currency?.name,
                    form: 'short',
                  }) + '/Team'
                : ''
            }
          />
          <DivisionToolbarItem
            title='TOTAL REVENUE'
            subTitle={
              registration?.total_paid !== undefined && registration?.team_cost
                ? i18n.formatCurrency(registration.total_paid, {
                    currency: registration?.currency?.name,
                    form: 'short',
                  })
                : ''
            }
          />
        </Flex>
        <DivisionSettings divisionId={id} divisionName={name} />
      </Flex>
      <DivisionTeams teams={teams} divisionId={id} />
    </div>
  )
}

export default RegistrationDivision
